(function () {
    function initSlider(ul) {
        const slides = Array.from(ul.children);
        if (slides.length <= 1) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'sliderSerie__wrapper';
        ul.parentNode.insertBefore(wrapper, ul);
        wrapper.appendChild(ul);

        ul.classList.add('sliderSerie__track');

        let current = 0;
        let startX = 0, startY = 0, diffX = 0;
        let isDragging = false, isScrolling = null;

        const pager = document.createElement('div');
        pager.className = 'slider-pager';
        wrapper.after(pager);

        function stepWidth() {
            if (slides.length < 2) return slides[0].offsetWidth;
            return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
        }

        function buildPager() {
            pager.innerHTML = '';
            slides.forEach((_, i) => {
                const dot = document.createElement('button');
                dot.className = 'slider-pager__dot' + (i === current ? ' is-active' : '');
                dot.setAttribute('aria-label', 'Page ' + (i + 1));
                dot.addEventListener('click', () => go(i));
                pager.appendChild(dot);
            });
        }

        function go(idx, animate = true) {
            current = Math.max(0, Math.min(idx, slides.length - 1));
            if (!animate) ul.classList.add('is-dragging');
            ul.style.transform = 'translateX(-' + (current * stepWidth()) + 'px)';
            if (!animate) requestAnimationFrame(() => ul.classList.remove('is-dragging'));
            pager.querySelectorAll('.slider-pager__dot')
                .forEach((d, i) => d.classList.toggle('is-active', i === current));
        }

        function onStart(x, y) {
            startX = x; startY = y; diffX = 0;
            isDragging = true; isScrolling = null;
            ul.classList.add('is-dragging');
        }
        function onMove(x, y) {
            if (!isDragging) return;
            const dx = x - startX, dy = y - startY;
            if (isScrolling === null) isScrolling = Math.abs(dy) > Math.abs(dx);
            if (isScrolling) { isDragging = false; ul.classList.remove('is-dragging'); return; }
            diffX = dx;
            ul.style.transform = 'translateX(' + (-(current * stepWidth()) + diffX) + 'px)';
        }
        function onEnd() {
            if (!isDragging) return;
            isDragging = false;
            ul.classList.remove('is-dragging');
            const threshold = stepWidth() * 0.15;
            if (diffX < -threshold) go(current + 1);
            else if (diffX > threshold) go(current - 1);
            else go(current);
        }

        wrapper.addEventListener('touchstart', e => onStart(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
        wrapper.addEventListener('touchmove', e => onMove(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
        wrapper.addEventListener('touchend', onEnd);
        wrapper.addEventListener('mousedown', e => { onStart(e.clientX, e.clientY); e.preventDefault(); });
        document.addEventListener('mousemove', e => { if (isDragging) onMove(e.clientX, e.clientY); });
        document.addEventListener('mouseup', onEnd);

        buildPager();

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => go(0, false));
        } else {
            go(0, false);
        }
    }

    document.querySelectorAll('ul.sliderSerie').forEach(initSlider);
})();